import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Row, Col } from "react-bootstrap";

const CardSkeleton = ({ rows = 2, columns = 5 }) => {
    return (
        <Row>
            {[...Array(rows)].map((_, rowIndex) => (
                <Col key={rowIndex} sm={12} md={6} lg={4} xl={3} className='mt-24'>
                    {[...Array(columns)].map((_, colIndex) => (
                        <Skeleton height={173} className="mt-24 " />
                    ))}
                </Col>
            ))}
        </Row>
    );
};

export default CardSkeleton;
